import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { redirect } from 'utils/paths'
import {
  fetchAllNotificationsRoutine,
  fetchUnseenNotificationsCounterRoutine
} from 'features/notifications/ducks/actions'
import {
  syncPushSubscription,
  persistSubscriptionFromWorker
} from 'utils/pushNotifications'

/**
 * Glue between the service worker's push handlers and the app:
 * - after login, re-attach an existing browser subscription to this user
 * - on an incoming push, refresh the bell counter and the notification list
 * - on a notification click, navigate client-side
 * - on a rotated subscription, persist the new one
 */
const usePushNotificationsBridge = isloggedin => {
  const dispatch = useDispatch()

  useEffect(() => {
    if (!isloggedin) return
    syncPushSubscription()
  }, [isloggedin])

  useEffect(() => {
    if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return undefined

    const handleMessage = event => {
      const message = event.data
      if (!message || typeof message.type !== 'string') return

      switch (message.type) {
        case 'PUSH_RECEIVED':
          if (isloggedin) {
            dispatch(fetchUnseenNotificationsCounterRoutine())
            dispatch(fetchAllNotificationsRoutine())
          }
          break
        case 'PUSH_NAVIGATE':
          if (message.url) redirect(message.url)
          break
        case 'PUSH_SUBSCRIPTION_CHANGED':
          if (isloggedin) persistSubscriptionFromWorker(message.subscription)
          break
        default:
          break
      }
    }

    navigator.serviceWorker.addEventListener('message', handleMessage)
    return () => navigator.serviceWorker.removeEventListener('message', handleMessage)
  }, [dispatch, isloggedin])
}

export default usePushNotificationsBridge
